<template>
  <main class="mmTwo">
    <Loader v-if="loader" />
    <div v-if="!loader" class="searchPanel">
      <div class="searchPanel__input">
        <p class="searchPanel__input__label">User ID</p>
        <div class="searchPanel__input-wrapper">
          <input type="text" v-model="searchInfo.user_id" placeholder="user ID" />
        </div>
      </div>
      <div class="searchPanel__input">
        <p class="searchPanel__input__label">User name</p>
        <div class="searchPanel__input-wrapper">
          <input type="text" v-model="searchInfo.username" placeholder="User name" />
        </div>
      </div>
      <div class="searchButton">
        <button @click="searchFilter">
          <img src="../../assets/images/search.svg" alt="" />
          <span>Search</span>
        </button>
      </div>
    </div>
    <div class="mmTwo__addSection" v-if="!loader">
      <div class="mmTwo__addInput">
        <input v-model="addUser" placeholder="id" />
        <button :class="{ disable: !addUser.length }" @click="addUserId">Добавить</button>
      </div>
      <div class="mmTwo__added" v-if="addedUsers.length">
        <span v-for="(userId, index) in addedUsers">
          {{ userId }}
          <img src="../../assets/images/close.svg" alt="delete" @click="deleteAddedUser(index)" />
        </span>
      </div>
      <input class="twoFa" v-if="addedUsers.length" placeholder="2FA" v-model="twoFA" />
      <button
        v-if="addedUsers.length"
        class="addUsers"
        :class="{ disable: !addedUsers.length || !twoFA }"
        @click="addUsersFetch"
      >
        Добавить пользователей в список
      </button>
      <p v-if="errorMsg" class="errorMsg">Ошибка</p>
    </div>
    <table v-if="!loader && mmTwoList.length">
      <thead>
        <tr>
          <td v-for="name in Object.keys(mmTwoList[0])">
            {{ name }}
          </td>
        </tr>
      </thead>
      <tbody>
        <tr v-for="tr in mmTwoList">
          <td>
            {{ tr._id }}
          </td>
          <td>
            {{ tr.username }}
          </td>
          <td>
            {{ tr.user_type }}
          </td>
          <td
            @click="changeStatus(tr)"
            :class="{ change: payloadStatus.user_ids.indexOf(tr._id) !== -1 }"
            class="status"
          >
            {{ tr.mm_beta_test }}
          </td>
        </tr>
      </tbody>
    </table>
    <div class="mmTwo__fa" v-if="!loader && payloadStatus.user_ids.length">
      <input v-model="payloadStatus.code" type="number" placeholder="Two FA" />
      <button :class="{ disable: !payloadStatus.code }" @click="changeStatusFetch">
        Изменить статус
      </button>
      <p class="errorMsg" v-if="errorMsg">Ошибка</p>
    </div>
    <p v-if="!loader && !mmTwoList.length" class="mmTwo__resultInfo">Нет резултата</p>
  </main>
</template>

<script>
import Loader from '../../components/Loader/Loader'
import http from '../../utils/http'
import cookie from 'vue-cookie'

import './mmTwoBeta.scss'

export default {
  name: 'MmTwoBeta',
  components: {
    Loader
  },
  data() {
    return {
      mmTwoList: [],
      loader: false,
      searchInfo: {
        user_id: '',
        username: ''
      },
      payloadStatus: {
        user_ids: [],
        state: false,
        code: ''
      },
      twoFA: '',
      addedUsers: [],
      errorMsg: false,
      addUser: ''
    }
  },
  mounted() {
    this.getMMList()
  },
  methods: {
    async getMMList(payload) {
      this.loader = true
      this.payloadStatus.user_ids = []
      this.payloadStatus.code = ''
      const response = await http.get(
        `https://auth.apineural.com/api/user/mm-beta-test/list?${payload ? payload : ''}`,
        cookie.get('token')
      )

      if (response.statusCode === 200) {
        this.mmTwoList = response.data
      }

      this.loader = false
    },
    async changeStatusFetch() {
      const response = await http.post(
        `https://auth.apineural.com/api/user/mm-beta-test/switch`,
        {
          user_ids: this.payloadStatus.user_ids,
          state: this.payloadStatus.state,
          code: this.payloadStatus.code
        },
        cookie.get('token')
      )
      if (response.statusCode === 200 && response.data.status) {
        this.getMMList()
      } else {
        this.errorMsg = true
        setTimeout(() => {
          this.errorMsg = false
        }, 2000)
      }
    },
    async addUsersFetch() {
      const response = await http.post(
        `https://auth.apineural.com/api/user/mm-beta-test/switch`,
        {
          user_ids: this.addedUsers,
          state: true,
          code: this.twoFA
        },
        cookie.get('token')
      )
      if (response.statusCode === 200 && response.data.status) {
        this.addedUsers = []
        this.twoFA = ''
        this.getMMList()
      } else {
        this.errorMsg = true
        setTimeout(() => {
          this.errorMsg = false
        }, 2000)
      }
    },
    searchFilter() {
      let searchPayload = ''
      for (let key in this.searchInfo) {
        if (this.searchInfo[key]) {
          searchPayload += `&${key}=${this.searchInfo[key]}`
        }
      }
      this.getMMList(searchPayload)
    },
    changeStatus(object) {
      object.mm_beta_test = !object.mm_beta_test
      if (this.payloadStatus.user_ids.indexOf(object._id) === -1) {
        this.payloadStatus.user_ids.push(object._id)
      } else {
        this.payloadStatus.user_ids.splice(this.payloadStatus.user_ids.indexOf(object._id), 1)
      }
    },
    addUserId() {
      this.addedUsers.push(this.addUser)
      this.addUser = ''
    },
    deleteAddedUser(index) {
      this.addedUsers.splice(index, 1)
    }
  }
}
</script>
